import React from "react";
import logger from "logger";
import TaskletCard from "TaskHistory/Tasklet/Tasklets/TaskletCard";
import CardContent from "@material-ui/core/CardContent";

export default function(props) {
  const { accountdetail } = props;
  return (
    <TaskletCard>
      <CardContent>
        {accountdetail.bestatkhero && (
          <div>
            <div className="infokey">Best Attack Hero(Gear)</div>
            <div className="infovalue" style={{ fontSize: "15px" }}>
              {accountdetail.bestatkhero.name}({accountdetail.bestatkhero.city})
            </div>
            <div className="infovalue" style={{ fontSize: "15px" }}>
              March:
              {accountdetail.bestatkhero.marchsize}
            </div>
            <div className="infovalue" style={{ fontSize: "15px" }}>
              Perc:
              {accountdetail.bestatkhero.life}/{accountdetail.bestatkhero.atk}/
              {accountdetail.bestatkhero.foelife}/
              {accountdetail.bestatkhero.foeatk}
            </div>
          </div>
        )}
        {accountdetail.bestatkherocombined && (
          <div>
            <div className="infokey">Best Attack Hero(Gear+Mount)</div>
            <div className="infovalue" style={{ fontSize: "15px" }}>
              {accountdetail.bestatkherocombined.name}(
              {accountdetail.bestatkherocombined.city})
            </div>
            <div className="infovalue" style={{ fontSize: "15px" }}>
              March:
              {accountdetail.bestatkherocombined.marchsize}
            </div>
            <div className="infovalue" style={{ fontSize: "15px" }}>
              Perc:
              {accountdetail.bestatkherocombined.life}/
              {accountdetail.bestatkherocombined.atk}/
              {accountdetail.bestatkherocombined.foelife}/
              {accountdetail.bestatkherocombined.foeatk}
            </div>
          </div>
        )}
        {accountdetail.bestdefhero && (
          <div>
            <div className="infokey">Best Defence Hero(Gear)</div>
            <div className="infovalue" style={{ fontSize: "15px" }}>
              {accountdetail.bestdefhero.name}({accountdetail.bestdefhero.city})
            </div>
            <div className="infovalue" style={{ fontSize: "15px" }}>
              March:
              {accountdetail.bestdefhero.marchsize}
            </div>
            <div className="infovalue" style={{ fontSize: "15px" }}>
              Perc:
              {accountdetail.bestdefhero.life}/{accountdetail.bestdefhero.atk}/
              {accountdetail.bestdefhero.foelife}/
              {accountdetail.bestdefhero.foeatk}
            </div>
          </div>
        )}
        {accountdetail.bestdefherocombined && (
          <div>
            <div className="infokey">Best Defence Hero(Gear+Mount)</div>
            <div className="infovalue" style={{ fontSize: "15px" }}>
              {accountdetail.bestdefherocombined.name}(
              {accountdetail.bestdefherocombined.city})
            </div>
            <div className="infovalue" style={{ fontSize: "15px" }}>
              March:
              {accountdetail.bestdefherocombined.marchsize}
            </div>
            <div className="infovalue" style={{ fontSize: "15px" }}>
              Perc:
              {accountdetail.bestdefherocombined.life}/
              {accountdetail.bestdefherocombined.atk}/
              {accountdetail.bestdefherocombined.foelife}/
              {accountdetail.bestdefherocombined.foeatk}
            </div>
          </div>
        )}
        <div className="infokey">CHS Stams Used/Available</div>
        <div className="infovalue" style={{ fontSize: "15px" }}>
          {accountdetail.chsstamused}/{accountdetail.chsstamlimit}
        </div>
        <div className="infokey">ECHS Stams Used/Available</div>
        <div className="infovalue" style={{ fontSize: "15px" }}>
          {accountdetail.echsstamused}/{accountdetail.echsstamlimit}
        </div>
        <div className="infokey">Runes</div>
        <div className="infovalue" style={{ fontSize: "15px" }}>
          {accountdetail.poppedruneatk}/{accountdetail.poppedrunelife}/
          {accountdetail.poppedrunefoeatk}/{accountdetail.poppedrunefoelife}
        </div>
      </CardContent>
    </TaskletCard>
  );
}
